
import ResetPasswordModel from "@/store/modules/system/user/reset-password";
import { Component, Mixins, FormModalMixins } from "@/lib";

@Component({name:"reset-password-modal"})
export default class ResetPassword extends Mixins(FormModalMixins) {
  model = new ResetPasswordModel();
  created() {
    Object.assign(this.config, { modelTitleL: "Users.ResetPassword",labelWidth:100, okAction: "system/user/resetPassword" });
  }
  get record() {
    return this.$store.state.system.user.resetPasswordData;
  }
  
  validatorData(rule, value, callback) {
    if (value !== this.model.newPassword) {
      callback(new Error(this.L("app.ChangePassword.ConfirmPasswordError")));
    } else {
      callback();
    }
  }

  formValidateRule = {
    confirmPassword: [
      {
        validator: this.validatorData,
        trigger: "blur",
      },
    ],
  };
}
